module.exports = __webpack_public_path__ + "images/psp/bicycleSizeGuide/bicycle-5x5.svg";